import { Button, Grid } from '@mui/material';
import { SahinModal } from '@sahinyazilim/sahinyazilim-components';
import { SahinSwitch } from 'common/components/SahinSwitch/SahinSwitch';
import { SahinTextField } from 'common/components/TextField/SahinTextField';
import { postAPI, updateAPI } from 'common/helper/apiHelpers';
import { Branch } from 'common/model/Branch';
import { forwardRef, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { mutate } from 'swr';
import { COMPONENT_TABLE_PATH } from '../List/BranchList';
import { BranchFormYup } from './BranchForm.types';

export const BranchForm = forwardRef<any, any>(
  ({ initialData, open, handleClose }, ref) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
      control,
      reset,
    } = useForm<Branch>({
      resolver: BranchFormYup,
      mode: 'onBlur',
    });

    const { t } = useTranslation();

    useEffect(() => {
      reset(initialData || { enabled: true });
    }, [initialData, reset]);

    const onSubmit = (data: Branch) => {
      let promise;
      if (initialData?.objectId) {
        promise = updateAPI(COMPONENT_TABLE_PATH, initialData.objectId, data);
      } else {
        promise = postAPI(COMPONENT_TABLE_PATH, data);
      }

      promise.then(() => {
        mutate(COMPONENT_TABLE_PATH);
        handleClose();
      });
    };

    return (
      <SahinModal
        open={open}
        handleClose={handleClose}
        width="50%"
        height="auto"
      >
        <Grid
          sx={{ height: '100%' }}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          container
        >
          <Grid alignContent="flex-start" spacing={3} container>
            <Grid xs={12} justifyContent="center" item container>
              <Controller
                control={control}
                name="enabled"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <SahinSwitch
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value ?? true}
                    inputRef={ref}
                    label="Aktif"
                    size={1}
                  />
                )}
              />
            </Grid>
            <Grid xs={12} item>
              <SahinTextField
                {...register('name')}
                error={errors?.name?.message}
                label={t('form.notHumanName.value')}
                placeholder={t('form.notHumanName.placeholder')}
                fullWidth
              />
            </Grid>
            <Grid xs={12} item>
              {/* <SahinTextField
                {...register('address')}
                error={errors?.address?.message}
                label="Adres"
                placeholder="Şube adresini girin"
                multiline
                rows={3}
                fullWidth
              /> */}
            </Grid>
            <Grid xs={12} justifyContent="flex-end" item container>
              <Button
                variant="contained"
                type="submit"
                sx={{ textTransform: 'uppercase' }}
              >
                {initialData?.objectId ? t('edit') : t('add')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </SahinModal>
    );
  },
);
